// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1xlIj","form":"styles_form__35UeM"};